module.exports = __webpack_public_path__ + "static/media/orange_logo.62a1f204.svg";